
import { defineComponent, ref, PropType, watch } from "vue";
import { MeditationType, LengthFilter } from "../../../composables/useFilters";

export default defineComponent({
  name: "FilterSortDrawer",
  props: {
    toggleOpenMenu: {
      type: Function as PropType<() => void>,
      required: true,
    },
    openMenu: Boolean,
    applyFilter: {
      type: Function,
      required: true,
    },
    removeFilter: {
      type: Function,
      required: true,
    },
    setSorting: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const isOpen = ref(props.openMenu);

    watch(
      () => props.openMenu,
      (newVal) => {
        isOpen.value = newVal;
      }
    );

    watch(isOpen, (newVal) => {
      if (!newVal) {
        props.toggleOpenMenu();
      }
    });

    const meditationOptions: MeditationType[] = [
      "Deep & Slow Looking",
      "Virtual Session",
      "In-Gallery Session",
      "In-Museum Session",
      "Art Mindfully",
      "Contemplative Exploration",
      "Interview/Conversation",
      "Talks",
      "Perspective",
      "Shared Experience",
      "Navigation",
      "Primer Virtual Session",
      "Primer Live Experience",
    ];

    const lengthOptions: LengthFilter[] = [5, 10, 15, 20];

    const selectedMeditationTypes = ref<MeditationType[]>([]);
    const selectedLengths = ref<LengthFilter[]>([]);

    const onMeditationTypeChange = (values: MeditationType[]) => {
      if (values.length) {
        props.applyFilter("meditationType", values);
      } else {
        props.removeFilter("meditationType");
      }
    };

    // When user changes length filters
    const onLengthChange = (values: LengthFilter[]) => {
      if (values.length) {
        props.applyFilter("audio.length", values);
      } else {
        props.removeFilter("audio.length");
      }
    };

    const sortOptions = [
      { title: "Title ↑", value: "title:asc" },
      { title: "Title ↓", value: "title:desc" },
      { title: "Artist ↑", value: "artist.name:asc" },
      { title: "Artist ↓", value: "artist.name:desc" },
      { title: "Duration ↑", value: "audio.length:asc" },
      { title: "Duration ↓", value: "audio.length:desc" },
    ];

    const selectedSort = ref<string | null>(null);

    const applySelectedSort = () => {
      if (selectedSort.value) {
        const [key, direction] = selectedSort.value.split(":");
        props.setSorting(key, direction as "asc" | "desc");
        return;
      }
    };

    return {
      isOpen,
      meditationOptions,
      lengthOptions,
      selectedMeditationTypes,
      selectedLengths,
      onMeditationTypeChange,
      onLengthChange,
      sortOptions,
      selectedSort,
      applySelectedSort,
    };
  },
});
